var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.302 6H21.5v2H9.302a2 2 0 0 1-3.465 0H3.5V6h2.337a2 2 0 0 1 3.465 0M3.5 13h9.788a2 2 0 0 0 3.465 0H21.5v-2h-4.747a2 2 0 0 0-3.465 0H3.5zm5.595 5H3.5v-2h5.595a2 2 0 0 1 3.465 0h8.94v2h-8.94a2 2 0 0 1-3.465 0",
    clipRule: "evenodd"
  })));
};
export default SvgFilters;